import { render, staticRenderFns } from "./StepCreate.vue?vue&type=template&id=bfe71f2c"
import script from "./StepCreate.vue?vue&type=script&lang=js"
export * from "./StepCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports